import { useParams } from '@/shared/modern-router';
// biome-ignore lint/nursery/noRestrictedImports: <explanation>
import { redirect } from '@modern-js/runtime/router';

/**
 * This loader is used to redirect the user to the general dashboard
 * when the user is on the dashboard page.
 */
export const PageModernLoaderRedirect = () => {
  const { slug } = useParams();
  const url: string = `/org/${slug}/my-team/dashboard/general/`;

  return redirect(url);
};
